import React, {
  useEffect, useRef, useState
} from 'react';
import { browserHistory } from 'react-router';
import { parseInt } from 'lodash';
import moment from 'moment';
import Header from '../../components/Header.js';
import {
  getApplicableDepuyMonths,
  getSales,
  generateTimedURL
} from '../../utils/utils.js';
import FilterIcon from '../../assets/images/filter-outline.png';
import FileIcon from '../../assets/images/file-document-outline-custom.png';
import DollarIcon from '../../assets/images/currency-usd.svg';
import HospitalIcon from '../../assets/images/hospital-box-outline-custom.png';
import SurgeonIcon from '../../assets/images/doctor-custom.png';
import withUser from '../../common/withUser.js';
import withLoader from '../../common/withLoader.js';
import withNotify from '../../common/withNotify.js';
import Bugsnag from '../../helpers/bugsnag.js';
import {
  getFormattedPercentage,
  getPercentageIncrease, getTeamData,
  getTerritoryData,
  shallowCompare,
  getSelectedTeamName
} from '../../common/globals.js';
import SelectOptionPage from './SelectOptionPage.js';
import BottomNavigation from './BottomNavigation.js';
import DataGroup from './DataGroup.js';
import withGoBack from '../../common/withGoBack.js';
import withSalesFilter from '../../common/withSalesFilter.js';
import { getRepReports } from '../../utils/db';

function SalesMetrics(props) {
  const availablePages = {
    TEAM: 'TEAM',
    SURGEON: 'SURGEON',
    HOSPITAL: 'HOSPITAL',
  };
  const headSection = useRef();
  const startTop = 41;
  const [caseTypesSalesData, setCaseTypesSalesData] = useState({});
  const [showMonthSelect, setShowMonthSelect] = useState(false);
  const [generalInfo, setGeneralInfo] = useState({
    updated: null,
    salesGoal: null,
  });
  const [selectedPage, setSelectedPage] = useState();
  const [depuyMonths, setDepuyMonths] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState();
  const [displaySales, setDisplaySales] = useState(true);
  const [stickyStart, setStickyStart] = useState(0);
  const [toggleSeparation, setToggleSeparation] = useState(false);
  const [filters, setFilters] = useState({});
  const [showFileIcon, setShowFileIcon] = useState(false);
  const [showFileName, setShowFileName] = useState('');

  const getSeparationString = () => {
    if (toggleSeparation && selectedPage) {
      if (selectedPage === availablePages.SURGEON) {
        return 'hospital';
      }
      if (selectedPage === availablePages.HOSPITAL) {
        return 'surgeon';
      }
    }
    return null;
  };

  const fetchSalesData = async (currentPage) => {
    props.setLoader(true);
    try {
      const res = await getSales(currentPage,
        { ...filters, CY: parseInt(selectedMonth.CY) },
        selectedMonth.CM);
      if (!res.data) {
        props.notify({ type: 'error', message: res.message });
        return;
      }
      const salesData = res.data;
      const allCases = [];
      const localCaseTypesSalesData = {};
      Object.keys(salesData).forEach((key) => {
        if (!Object.hasOwn(localCaseTypesSalesData, key)) {
          localCaseTypesSalesData[key] = {};
        }

        allCases.push(...salesData[key]);
        const uniqueCaseTypes = [...new Set(salesData[key].map((item) => item.CaseType))];
        uniqueCaseTypes.forEach((caseType) => {
          localCaseTypesSalesData[key][caseType] = salesData[key]
            .filter((item) => item.CaseType === caseType);
        });
      });
      // const updated = moment(res?.last_updated)
      //   .format('MM/DD/YY hh:mm A');
      const updated = moment(res?.last_updated)
        .format('dddd, MM/DD/YY');
      getAndSetGeneralInfo(allCases, updated);
      setCaseTypesSalesData(localCaseTypesSalesData);
    } catch (e) {
      Bugsnag.notify(e);
    } finally {
      props.setLoader(false);
    }
  };

  const getAndSetGeneralInfo = (data, updated) => {
    const sortedByDate = data
      .sort((a, b) => new Date(b.DateUpdated) - new Date(a.DateUpdated));
    const mostRecentData = sortedByDate[0];
    setGeneralInfo({
      updated,
      salesGoal: mostRecentData.SalesGoal ? parseInt(mostRecentData.SalesGoal) : null,
    });
  };

  const removeFilterItem = (key, filterItem) => {
    const newFilters = {};
    Object.keys(filters).forEach((filterKey) => {
      if (filterKey === key) {
        newFilters[filterKey] = filters[filterKey].filter((item) => item !== filterItem);
        return;
      }
      newFilters[filterKey] = filters[filterKey];
    });
    props.setSalesFilter(newFilters);
    setFilters(newFilters);
  };

  const _getReportData = async () => {
    try {
      const repReports = await getRepReports();
      // console.log(repReports);
      repReports.map((report) => {
        if (report.group === 'SALES' && (report.name === 'SalesMetrics.xlsx' || report.name === 'SalesMetrics.xls')) {
          setShowFileIcon(true);
          setShowFileName(report.name);
        }
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const _onReport = async () => {
    try {
      const {
        notify, setLoader, user
      } = props;
      const generateTimedURLData = {
        team: await getSelectedTeamName(),
        entity_type: 'reports',
        entity_id: showFileName,
        token: user.token,
        key: user.userKey
      };
      setLoader(true);
      generateTimedURL(generateTimedURLData).then((response) => {
        setLoader(false);
        const { status, message, data } = response;
        if (status) {
          if (!response.hasOwnProperty('data')) {
            return;
          }
          window.open(data, '_blank', 'fullscreen=yes');
          return false;
        }
        notify({ type: 'error', message });
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  useEffect(() => {
    props.setLoader(true);
    const { user } = props;
    const { isSalesMetrics } = getTerritoryData(user);
    const { salesAccess } = getTeamData(user);
    if (!isSalesMetrics || !salesAccess) {
      browserHistory.replace('/');
      return;
    }
    try {
      setFilters(props.salesFilter);
      _getReportData();
      const selectedPageQuery = props.location.search.split('=')[1];
      if (selectedPageQuery) {
        setSelectedPage(selectedPageQuery);
      } else {
        setSelectedPage(availablePages.TEAM);
        browserHistory.replace(`${props.location.pathname}?page=${availablePages.TEAM}`);
      }
      const fetchApplicableMonths = async () => {
        const monthsRes = await getApplicableDepuyMonths();
        if (!monthsRes.data) {
          props.notify({ type: 'error', message: monthsRes.message });
          return;
        }
        setDepuyMonths(monthsRes.data);
        const onlyPresentAndPastMonths = monthsRes.data
          .filter((month) => new Date() > new Date(month.MonthBeg));
        setSelectedMonth(onlyPresentAndPastMonths[0]);
      };
      fetchApplicableMonths()
        .finally(() => {
          props.setLoader(false);
        });
      return () => {
        props.setSalesFilter({});
      };
    } catch (e) {
      Bugsnag.notify(e);
    }
  }, []);

  useEffect(() => {
    if (headSection.current) {
      setStickyStart(startTop + headSection.current.clientHeight + 4);
    } else {
      setStickyStart(0);
    }
  }, [headSection.current]);

  useEffect(() => {
    if (!selectedPage || !selectedMonth) return;
    window.scrollTo(0, 0);
    setCaseTypesSalesData({});
    fetchSalesData(selectedPage);
    setStickyStart(startTop + headSection.current.clientHeight + 4);
  }, [selectedPage, filters, selectedMonth]);

  useEffect(() => {
    setToggleSeparation(false);
  }, [selectedPage]);

  return (
    <section className="list-section">
      <Header
        title={showMonthSelect ? 'Depuy Month' : 'Sales Metrics'}
        goBack={() => {
          if (showMonthSelect) {
            setShowMonthSelect(false);
            return;
          }
          browserHistory.goBack();
        }}
        showRighIcon={showFileIcon}
        actionRighIcon={_onReport}
      />
      {
        !showMonthSelect ? (
          <div
            className="container backorders-np" style={{
              marginBottom: `${startTop}px`
            }}
          >
            <section
              className="bg-theme"
              ref={headSection}
              style={{
                padding: '8px 8px 16px',
                display: 'flex',
                flexDirection: 'column',
                position: 'sticky',
                top: '45px',
                backgroundColor: 'var(--background-gray)',
                gap: '8px',
                overflowX: 'hidden',
              }}
            >
              <div className="row">
                <div className="col-8">Invoiced through: {generalInfo.updated}</div>
                <div className="col-4 text-end">
                  <a
                    role="button"
                    tabIndex={0}
                    onClick={() => setDisplaySales(!displaySales)}
                    style={{ display: 'inline-block' }}
                  >
                    {displaySales ? (
                      <img
                        className="optimize-icon"
                        src={FileIcon}
                        alt="file-icon"
                      />
                    ) : (
                      <img
                        className="optimize-icon"
                        src={DollarIcon}
                        alt="dollar-icon"
                      />
                    )}
                  </a>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <button
                    type="button"
                    className="btn btn-sm btn-theme-alt btn-theme-outline-alt"
                    style={{ padding: '2px 12px', fontWeight: 'normal' }}
                    onClick={() => setShowMonthSelect(true)}
                  >
                    Month
                  </button>
                </div>
                <div className="col-4">
                  <span style={{
                    display: 'flex',
                    gap: '20px',
                  }}
                  >
                    <a
                      role="button"
                      tabIndex={0}
                      onClick={() => browserHistory.push(`/sales-filter?filterPage=${selectedPage}`)}
                    >
                      <img
                        className="optimize-icon cursor-pointer"
                        src={FilterIcon}
                        alt="filter-icon"
                      />
                    </a>
                    {
                      selectedPage !== availablePages.TEAM ? (
                        <a
                          role="button"
                          tabIndex={0}
                          onClick={() => setToggleSeparation(!toggleSeparation)}
                          style={{
                            opacity: !toggleSeparation ? 1 : 'var(--selected-opacity)',
                          }}
                        >
                          {
                            selectedPage === availablePages.SURGEON ? (
                              <img
                                className="optimize-icon cursor-pointer"
                                src={HospitalIcon}
                                alt="filter-icon"
                              />
                            ) : (
                              <img
                                className="optimize-icon cursor-pointer"
                                src={SurgeonIcon}
                                alt="filter-icon"
                              />
                            )
                          }
                        </a>
                      ) : null
                    }
                  </span>
                </div>
                {!!generalInfo.salesGoal && (
                  <div className="col-4 flex text-end my-auto">
                    Goal: {getFormattedPercentage(generalInfo.salesGoal)}
                  </div>
                )}
              </div>
              <div className="button-scrollarea">
                {Object.keys(filters).map((key) => filters[key].map((filter, i) => (
                  <div
                    key={`account-${i + 1}`}
                    className="filterTagShipments"
                  >
                    <p style={{
                      width: '90%',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      marginBottom: 0
                    }}
                    >
                      {filter}
                    </p>
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => removeFilterItem(key, filter)}
                      style={{
                        marginLeft: 16,
                        cursor: 'pointer'
                      }}
                    >
                      x
                    </div>
                  </div>
                )))}
              </div>
            </section>
            {Object.keys(caseTypesSalesData).length
              ? Object.keys(caseTypesSalesData).sort().map((key) => {
                const structuredData = getStructuredMetricsData(
                  caseTypesSalesData[key],
                  displaySales
                );
                if (Object.keys(structuredData).length === 0) return null;
                return (
                  <DataGroup
                    key={key}
                    title={key}
                    displaySales={displaySales}
                    caseTypesSalesData={structuredData}
                    stickyStart={stickyStart}
                    separateBy={getSeparationString()}
                  />
                );
              }) : Object.keys(filters).length ? (
                <p className="text-center">Data not available</p>
              ) : (
                <p className="text-center">There is no sales data to be displayed.</p>
              )}
            <BottomNavigation
              selectedPage={selectedPage}
              availablePages={availablePages}
              onPageSelect={(value) => {
                setSelectedPage(value);
                setFilters({});
                props.setSalesFilter({});
                browserHistory.replace(`${props.location.pathname}?page=${value}`);
              }}
            />
          </div>
        ) : (
          <SelectOptionPage
            data={depuyMonths.map((month, index) => ({
              optionTitle: `${month.CM} ${month.CY} (${month.MonthBeg} - ${month.MonthEnd})`,
              optionValue: index,
            }))}
            setSelectedValue={(value) => {
              setSelectedMonth(depuyMonths[value]);
              setShowMonthSelect(false);
            }}
            selectedValue={depuyMonths
              .findIndex((month) => shallowCompare(month, selectedMonth))}
          />
        )
      }
    </section>
  );
}

const getStructuredData = (data, isSales = true) => {
  if (isSales) {
    return {
      PY: data.PY,
      CY: data.CY,
      SalesPY: data.SalesPY ? parseInt(data.SalesPY) : null,
      SalesPYTD: data.SalesPYTD ? parseInt(data.SalesPYTD) : null,
      SalesCYTD: data.SalesCYTD ? parseInt(data.SalesCYTD) : null,
      CM: data.CM,
      SalesPM: data.SalesPM ? parseInt(data.SalesPM) : null,
      SalesPMTD: data.SalesPMTD ? parseInt(data.SalesPMTD) : null,
      SalesCMTD: data.SalesCMTD ? parseInt(data.SalesCMTD) : null,
      NotBilled: data.NotBilled ? parseInt(data.NotBilled) : null,
      YTD_Chg: data.SalesPYTD && parseInt(data.SalesPYTD)
        ? getPercentageIncrease(parseInt(data.SalesCYTD), parseInt(data.SalesPYTD))
        : null,
      MTD_Chg: data.SalesPMTD && parseInt(data.SalesPMTD)
        ? getPercentageIncrease(parseInt(data.SalesCMTD), parseInt(data.SalesPMTD))
        : null,
      hospital: data.CustomerName,
      surgeon: data.SurgeonName,
    };
  }
  return {
    PY: data.PY,
    CY: data.CY,
    SalesPY: data.CasesPY ? parseInt(data.CasesPY) : null,
    SalesPYTD: data.CasesPYTD ? parseInt(data.CasesPYTD) : null,
    SalesCYTD: data.CasesCYTD ? parseInt(data.CasesCYTD) : null,
    CM: data.CM,
    SalesPM: data.CasesPM ? parseInt(data.CasesPM) : null,
    SalesPMTD: data.CasesPMTD ? parseInt(data.CasesPMTD) : null,
    SalesCMTD: data.CasesCMTD ? parseInt(data.CasesCMTD) : null,
    NotBilled: data.CasesNotBilled ? parseInt(data.CasesNotBilled) : null,
    YTD_Chg: data.CasesPYTD && parseInt(data.CasesPYTD)
      ? getPercentageIncrease(parseInt(data.CasesCYTD), parseInt(data.CasesPYTD))
      : null,
    MTD_Chg: data.CasesPMTD && parseInt(data.CasesPMTD)
      ? getPercentageIncrease(parseInt(data.CasesCMTD), parseInt(data.CasesPMTD))
      : null,
    surgeon: data.SurgeonName,
    hospital: data.CustomerName,
  };
};

const getStructuredMetricsData = (data, isSales = true) => {
  const newData = {};
  Object.keys(data).forEach((key) => {
    const dataForCategory = data[key].map((item) => getStructuredData(item, isSales));
    if (dataForCategory.length) {
      newData[key] = dataForCategory;
    }
  });
  return newData;
};

export default withGoBack(
  withLoader(
    withUser(
      withNotify(
        withSalesFilter(
          SalesMetrics
        )
      )
    )
  )
);
